import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ReportsService } from 'src/app/features/reports/reports.service'; 
import { formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-loyalty-report-smart',
  template: `<app-loyalty-report [loyality]="loyality" [summary]="summary"></app-loyalty-report>`,
  styles: [
  ]
})
export class LoyaltyReportSmartComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  loyality: any =[];
  summary: any = [];

  constructor(private reportsService: ReportsService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit()
    
    let curdate = new Date().getFullYear().toString() +'-'+(new Date().getMonth() + 1).toString()+'-01';
    let endDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    let startDate = formatDate(curdate, 'yyyy-MM-dd', 'en');
    let params: any = new HttpParams().set('startDate', startDate).set('endDate', endDate )


    this.reportsService.getloyalitySummary(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.summary = resData;
      }
    })    
	
    this.reportsService.getloyality(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.loyality=resData;
      }
    })
	}

  ngOnDestroy() {
    super.ngOnDestroy()
  }
  
}
